'use client';

import React from 'react';
import { Modal } from '@mantine/core';
import DocReviewPanel from '@/components/doc-review/DocReviewPanel';

type DocReviewAction = {
  type: 'OPEN_MODAL' | 'CLOSE_MODAL';
  [prop: string]: any;
};

const initialState = {
  modalOpened: false,
};

const reducer = (state: typeof initialState, action: DocReviewAction) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        ...state,
        modalOpened: true,
      };
    case 'CLOSE_MODAL':
      return { ...state, modalOpened: false };
    default:
      return state;
  }
};

export const DocReviewContext = React.createContext({
  state: initialState,
  dispatch: (action: DocReviewAction) => {},
});

export const DocReviewProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <DocReviewContext.Provider value={{ state, dispatch }}>
      {children}

      <Modal
        centered
        size={450}
        padding={0}
        radius={20}
        withCloseButton={false}
        opened={state.modalOpened}
        onClose={() => {
          dispatch({ type: 'CLOSE_MODAL' });
        }}
      >
        <DocReviewPanel
          onCloseRequest={() => {
            dispatch({ type: 'CLOSE_MODAL' });
          }}
        />
      </Modal>
    </DocReviewContext.Provider>
  );
};
